'use client';

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import Sidebar from './Sidebar';
import { getSession } from '@/lib/technicianSession';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  const router = useRouter();

  useEffect(() => {
    const session = getSession();
    if (!session) {
      router.replace('/login');
    }
  }, [router]);

  return (
    <div className="flex h-screen overflow-hidden" style={{ backgroundColor: 'var(--background)' }}>
      <Sidebar />
      {/* Main content — responsive padding for tablet landscape/portrait */}
      <main className="flex-1 overflow-y-auto scrollbar-thin">
        <div className="min-h-full px-4 py-4 sm:px-6 sm:py-5 lg:px-8 lg:py-6 xl:px-10 2xl:px-12">
          {children}
        </div>
      </main>
    </div>
  );
}